export default {
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-grid',
  },
  {
    title: true,
    name: ' ',
    class: '',
    wrapper: {
      element: '',
      attributes: {}
    }
  },
  {
    name: 'Publishers',
    url: '/publishers',
    icon: 'icon-globe'
  },
  {
    name: 'Listings',
    url: '/listings',
    icon: 'icon-layers'
  },
  // {
  //   name: 'Replies',
  //   url: '/replies',
  //   icon: 'icon-bubbles'
  // },
  {
    name: 'My Account',
    url: '/account',
    icon: 'icon-user'
  }
  ]
}
